module.exports = __webpack_public_path__ + "public/img/benyue.d66106c4.png";